var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1469 612L1469 640",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1469.5,
    cy: 607.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1464.99 607.19C1464.99 603.283 1468.29 600.117 1472.36 600.117C1472.94 600.117 1473.51 600.184 1474.06 600.308C1472.74 599.48 1471.19 599 1469.52 599C1464.81 599 1461 602.806 1461 607.5C1461 612.194 1464.81 616 1469.52 616C1471.81 616 1473.89 615.093 1475.43 613.62C1474.49 614.032 1473.45 614.263 1472.36 614.263C1468.29 614.263 1464.99 611.096 1464.99 607.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1478.4 606.6L1478.37 604.146L1476.54 605.719L1474.3 605.056L1475.11 607.337L1473.77 609.381L1476.1 609.218L1477.5 611.144L1478.13 608.763L1480.34 607.909L1478.4 606.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.48b5b736dfb5deaef7b9d91e5dd8e825.svg";
export { ForwardRef as ReactComponent };